import React, { useState, useEffect } from 'react';
import { openDemoBookingModal } from '../../../utils/functions';
import apiService from '../../../services/api';

const IRMModule = () => {
  const [irmOffers, setIrmOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadIRMOffers();
    // Refresh every 30 seconds
    const interval = setInterval(loadIRMOffers, 30000);
    return () => clearInterval(interval);
  }, []);

  const loadIRMOffers = async () => {
    try {
      const response = await apiService.getPolymerLiveDemand();
      
      // Handle API response structure: { message: "List successfully", data: [...] }
      // API service returns: { success: true, data: [...] }
      let dataArray = [];
      
      // Direct check for data array - prioritize this
      if (response && response.data && Array.isArray(response.data)) {
        dataArray = response.data;
      }
      // Check if response itself is an array
      else if (Array.isArray(response)) {
        dataArray = response;
      }
      // Try to find any array property in response object
      else if (response && typeof response === 'object') {
        for (const key in response) {
          if (Array.isArray(response[key])) {
            dataArray = response[key];
            break;
          }
        }
      }
      
      if (dataArray && dataArray.length > 0) {
        // Transform API response to match UI structure
        const transformedOffers = dataArray.map((item, index) => {
          // Build location: "City,State" or "City,StateShort" format
          let location = '';
          if (item.city_name && String(item.city_name).trim() !== '' && String(item.city_name).trim() !== 'null') {
            location = String(item.city_name).trim();
            if (item.state_short_name && String(item.state_short_name).trim() !== '' && String(item.state_short_name).trim() !== 'null') {
              location = location + ',' + String(item.state_short_name).trim();
            } else if (item.state_name && String(item.state_name).trim() !== '' && String(item.state_name).trim() !== 'null') {
              location = location + ',' + String(item.state_name).trim();
            }
          } else if (item.state_short_name && String(item.state_short_name).trim() !== '' && String(item.state_short_name).trim() !== 'null') {
            location = String(item.state_short_name).trim();
          } else if (item.state_name && String(item.state_name).trim() !== '' && String(item.state_name).trim() !== 'null') {
            location = String(item.state_name).trim();
          }
          
          return {
            id: item.id || index,
            grade_name: item.grade_name || '',
            process_name: item.process_name || '',
            brand_name: item.brand_name || '',
            grade_code_name: item.grade_code_name || '',
            grade_code_mfi_value: item.grade_code_mfi_value || '',
            qty: item.qty || '0',
            location: location || 'N/A'
          };
        });
        
        // Show only 1 offer
        setIrmOffers(transformedOffers.slice(0, 1));
      } else {
        setIrmOffers([]);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error loading IRM offers:', error);
      setIrmOffers([]);
      setLoading(false);
    }
  };

  return (
    <div className="module-card sellers-grade-module">
      <div className="module-header">
        <div className="module-icon">
          <i className="fas fa-users"></i>
        </div>
        <h3>Polymer Live Demand (IRM)</h3>
      </div>
      <div className="sellers-grade-content" id="sellers-grade-content">
        {loading ? (
          <div className="irm-loading">
            <i className="fas fa-spinner fa-spin"></i>
            <p>Loading IRM offers...</p>
          </div>
        ) : irmOffers && Array.isArray(irmOffers) && irmOffers.length > 0 ? (
          <div className="irm-offers-list">
            {irmOffers.map((offer, index) => {
              if (!offer) {
                return null;
              }
              const gradeProcess = [offer.grade_name, offer.process_name].filter(Boolean).join(' ').trim() || 'N/A';
              const brandCode = [offer.brand_name, offer.grade_code_name].filter(Boolean).join(' ').trim();
              
              return (
                <div key={offer.id || `offer-${index}`} className="irm-offer-item">
                  <div className="irm-offer-top-line">
                    <span className="irm-grade-process">{gradeProcess}</span>
                    {brandCode && (
                      <span className="irm-brand-code">{brandCode}</span>
                    )}
                    {offer.grade_code_mfi_value && (
                      <span className="irm-mfi-badge">{offer.grade_code_mfi_value}</span>
                    )}
                  </div>
                  <div className="irm-offer-bottom-line">
                    <i className="fas fa-cube irm-icon"></i>
                    <span className="irm-quantity">{offer.qty || '0'} MT</span>
                    <i className="fas fa-map-marker-alt irm-icon"></i>
                    <span className="irm-location">{offer.location || 'N/A'}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="irm-loading">
            <p>No IRM offers available at the moment.</p>
          </div>
        )}
      </div>
      <button 
        className="btn btn-primary btn-get-quote" 
        onClick={() => openDemoBookingModal('polymer')}
      >
        <i className="fas fa-calculator"></i>
        <span>Book Demo</span>
      </button>
    </div>
  );
};

export default IRMModule;

